import { defineStore } from "pinia";
import { useContractStore } from "./contract";
import { useContractInfoStore } from "@/store/contractinfo";
import { useInternalSplitStore } from "./internalsplit";
import OrderMediaItemJs from "@/models/orderMediaItem";
import mediaapi from "@/network/mediaitem";
import optional from "@/network/optional";
import validation from '@/assets/js/validation.js';

import contractnet from "@/network/contractnet";
const messageConfig = require("@/models/messageConfig.js");

const rulesJs = require('@/views/contract/js/contractMediaRules.js');
const rules = rulesJs.contractMediaRules;

export const useMediaItemsStore = defineStore("mediaitem", {
  state: () => ({
    OrderMedias: [],
    // 当前编辑的媒体下标
    EditIndex: -1,
    // 媒体选择编辑下表
    MediaSelectIndex: -1,
    // 媒体列表
    OrderMediaItems: [],
    OrderMediaItemsJson: "",
    // 媒体过滤条件
    MediaSearch: {
      tier: "bus",
    },
    //
    MediaMode: "",
    // 当前已选择的媒体
    MediaItemsSelected: [],
    // 当前已选中的媒体Id
    MediaIdsSelected: [],
    // 当前选择的时间
    MediaCampaginPeriod: [],
    // 当前媒体是否更新
    isMediaChanged: false,
    MediaChangedMessage: messageConfig.getMessage("mediachange"),
    LocationOptions: [],
    CityOptions: [],
    FormatOptions: [],
    MediaOptions: [],
    MediaList: [],
    MediaSettings: [],
    DistrictOptions: [],
    ShelterNoAddressOptions: [],
    ShelterNoAddressOptionsOld: [],
  }),
  getters: {
    isFilterMedia(state) {
      return state.MediaMode === "Add";
    },
    isEditMediaDialog(state) {
      return state.MediaSelectIndex > -1;
    },
  },
  actions: {
    // 刷新数据
    async RefreshMediaItems() {
      const useContract = useContractStore()
      const ContractId = useContract.Id

      // 重置Options
      this.filterMediaOptions()

      const mediaitem_res = await contractnet
        .ContractMediaItems(ContractId)
        .then((res) => res);

      this.OrderMediaItems = mediaitem_res.data;

      const OrderMediaItemsModel = this.OrderMediaItems.map(t => OrderMediaItemJs.OrderMediaItemEntity(t))
      this.OrderMediaItemsJson = JSON.stringify(OrderMediaItemsModel)

      this.OrderMediaItems.map((t) => {
        t.dates = [t.startDate, t.endDate];
        t.media_plan = JSON.parse(t.mediaPlan || "{}")
        t.unitRateOptionObject = JSON.parse(t.unitRateOption || "{}")
      });
      //获取media Append 下拉数据BusShelter
      //this.GetBusShelterLocationOptions();

    },

    async toSave() {
      if (this.OrderMediaItems.length === 0) {
        return messageConfig.getMessage('validmediarequire')
      }

      var firstMsg = ""
      for (var i = 0; i < this.OrderMediaItems.length; i++) {
        var validMsg = await this.validate(i).then(res => res)

        if (firstMsg === "" && validMsg !== "") {
          firstMsg = validMsg
        }
      }

      if (firstMsg !== "") {
        return firstMsg
      }

      var message = await this.SaveData().then(msg => msg);

      if (message === "") {
        this.isMediaChanged = await this.bMediaChanged().then(res => res)

        await this.RefreshMediaItems()
      }

      return message;
    },
    /**
     * 保存数据
     * @returns
     */
    async SaveData() {
      const res = await contractnet
        .changeMediaItems(this.OrderMediaItems)
        .then((res) => res);
      var message = res.data || "";

      return message;
    },
    async validate(index) {
      var source = this.OrderMediaItems[index];
      var errors = await validation.validate(source, rules).then((err1) => err1);
      var message = errors.length > 0 ? errors[0].message : ""
      this.OrderMediaItems[index].validate = errors
      return message;
    },
    /**
     * 验证保存按钮
     */
    ValidationSave() {
      this.MediaItemsRules.mediaItem.validation = !(
        this.OrderMediaItems.length === 0
      );
      this.MediaItemsRules.grossRate.validation = !(
        this.OrderMediaItems.filter((t) => t.grossRate <= 0).length > 0
      );
      this.MediaItemsRules.quantity.validation = !(
        this.OrderMediaItems.filter((t) => t.quantity <= 0).length > 0
      );
    },
    /**
     * 验证媒体选择OK按钮
     */
    ValidationMediaSelectOK() {
      this.MediaSelectRules.medias.validation = !(
        this.MediaItemsSelected.length === 0
      );

      this.MediaSelectRules.campaignPeriod.validation = !(
        this.MediaCampaginPeriod.length === 0
      );
      if (this.MediaItemsSelected.find((t) => t.planId == "")) {
        this.MediaSelectRules.planNull.validation = false;
      }
    },
    /**
     * 重置过滤条件
     */
    resetMediaSelect() {
      this.MediaSearch.tier = "bus";
      this.MediaSearch.contractType = "";
      this.MediaSearch.city = [];
      this.MediaSearch.locationOrOperator = [];
      this.MediaSearch.format = [];
      this.MediaCampaginPeriod = [];
      this.MediaIdsSelected = [];
      this.MediaItemsSelected = [];

      this.filterMediaOptions();

      this.MediaSelectIndex = -1;
    },
    /**
     * 点击New Item/Edit Media
     */
    showMedia(index) {
      // 更新当前正在编辑中的媒体
      this.MediaSelectIndex = index;

      // 更新Media Select模式
      this.MediaMode = index === -1 ? "Add" : "Edit";

      this.MediaItemsSelected = [];
      this.MediaCampaginPeriod = []
      if (index !== -1) {
        var MediaObj = this.OrderMediaItems[index];

        const useContract = useContractStore();

        // Plans
        MediaObj.plans =
          useContract.MediaList.find((t) => t.mediaId === MediaObj.mediaId)
            ?.plans || [];
        this.MediaItemsSelected = [MediaObj];

        // Media Period
        this.MediaCampaginPeriod = [MediaObj.startDate, MediaObj.endDate];
      }
    },
    /**
     * 更改媒體提示信息
     * @returns 
     */
    async MediaChangedAlertMessage() {
      // const useInternalSplit = useInternalSplitStore()

      // var message = ""
      // // 是否已经产生InternalSplit
      // if ((useInternalSplit.ContractSplit.id || 0) === 0) {
      //   await useInternalSplit.getContractSplit(this.OrderMediaItems[0].contractId)
      // }
      // const bHasInternalSplit = (useInternalSplit.ContractSplit?.id || 0) > 0

      // // 判断媒体是否改变
      // if (bHasInternalSplit) {
      //   const OrderMediaItemsjson = JSON.stringify(this.OrderMediaItems.map(t => OrderMediaItemJs.OrderMediaItemEntity(t)))

      //   if (OrderMediaItemsjson !== this.OrderMediaItemsJson) {
      //     message = messageConfig.getMessage("mediachange")
      //   }

      // }
      // return message;

    },
    async bMediaChanged() {
      const useInternalSplit = useInternalSplitStore()

      // 是否已经产生InternalSplit
      if ((useInternalSplit.ContractSplit.id || 0) === 0) {
        await useInternalSplit.getContractSplit(this.OrderMediaItems[0].contractId)
      }
      const bHasInternalSplit = (useInternalSplit.ContractSplit?.id || 0) > 0

      // 判断媒体是否改变
      if (bHasInternalSplit) {
        const OrderMediaItemsJson = JSON.stringify(this.OrderMediaItems.map(t => OrderMediaItemJs.OrderMediaItemEntity(t)))
        return (OrderMediaItemsJson !== this.OrderMediaItemsJson)
      }

      return false
    },
    /**
     * 媒体选项
     * @param {Object} MediaSearch 媒体查询条件
     */
    async getMediaList(contractType, entity) {
      const tier = 'outdoor';
      var bSearch = false;

      if (this.MediaSearch.tier !== tier) {
        this.MediaSearch.tier = tier;
        bSearch = true;
      }
      if (this.MediaSearch.contractType !== contractType) {
        this.MediaSearch.contractType = contractType;
        bSearch = true;
      }
      if (this.MediaList.length === 0) {
        bSearch = true;
      }
      if (this.MediaSearch.productionCompanyEntityCode != useContractInfoStore().Contract.productionCompanyEntityCode) {
        this.MediaSearch.productionCompanyEntityCode = useContractInfoStore().Contract.productionCompanyEntityCode;
        bSearch = true;
      }
      if (this.MediaSearch.Entity !== entity) {
        bSearch = true;
      }

      this.MediaSearch.City = ["Hong Kong", "Macau", "Zhuhai", "Shenzhen"]
      this.MediaSearch.Entity = entity == "GP" ? "**" : entity

      if (bSearch) {
        const Options_res = await mediaapi.MediaOptions(this.MediaSearch).then((res) => res);
        this.MediaList = Options_res.data.mediaDatas
        this.MediaSettings = Options_res.data.mediaSettings
      }

    },
    /**
     * 过滤媒体选项
     * @param {Object} MediaSearch 媒体查询条件 
     */
    filterMediaOptions(city, location, format) {
      var cityFilter = city || []
      const locationFitler = location || []
      const formatFitler = format || []


      var MediasObj = this.MediaList

      // 城市选项
      var citys = MediasObj?.map(t => t.city)?.sort() || []
      this.CityOptions = Array.from(new Set(citys))?.map(t => { return { value: t, label: t } }) || []
      if (cityFilter.length > 0) {
        MediasObj = MediasObj.filter(t => cityFilter.indexOf(t.city) >= 0)
      }
      // 位置选项
      var locations = MediasObj?.map(t => t.location).sort() || []
      this.LocationOptions = Array.from(new Set(locations))?.map(t => { return { value: t, label: t } }) || []
      if (locationFitler.length > 0) {
        MediasObj = MediasObj.filter(t => locationFitler.indexOf(t.location) >= 0)
      }

      // 类型选项
      var formats = MediasObj?.map(t => t.format).sort() || []
      this.FormatOptions = Array.from(new Set(formats))?.map(t => { return { value: t, label: t } }) || []
      if (formatFitler.length > 0) {
        MediasObj = MediasObj.filter(t => formatFitler.indexOf(t.format) >= 0)
      }

      this.MediaOptions = MediasObj?.map((t) => {
        var medias =
          t.mediaCode +
          " - " +
          t.location +
          " - " +
          t.format +
          " - " +
          t.mediaName +
          " - " +
          t.internalCode;

        if (t.subgroupCode) {
          medias = medias + ` (${t.subgroupCode})`;
        }


        return { value: t.mediaId, label: medias, status: "Active" }
      });
    },
    // 获取media Append 下拉数据BusShelter
    async GetBusShelterLocationOptions() {
      if (this.DistrictOptions.length < 1 || this.shelterNoAddressOptions < 1) {
        const result = await optional
          .getBusShelterLocationOptions()
          .then((res) => res);
        this.DistrictOptions = result.data.districtOptions;
        this.ShelterNoAddressOptions = result.data.shelterNoAddressOptions;
        this.ShelterNoAddressOptionsOld = result.data.shelterNoAddressOptions;
      }
    },
  },
});
